import EducationMasterForm from "./EducationMasterForm";

const AddEducation = () => (
  <EducationMasterForm
    title="Education"
    backPath="/all-education"
    submitLabel="Add Education"
    addEndpoint="/admin/add-education"
    getEndpoint="/admin/get-education"
    updateEndpoint="/admin/update-education"
    responseKey="Education"
    includeCategory
  />
);

export default AddEducation;
